module.exports = __webpack_public_path__ + "static/media/G.0163c6c0.svg";